import styled from 'styled-components';

export const Container = styled.div`
  @media (min-width: 769px) {
    padding: 20px;
  }

  max-width: 100vw;
`;

export const QuestPageInfo = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 50px;
  margin-bottom: 50px;
  align-items: center;
  gap: 50px;

  .questPageTitle {
    font-size: 32px;
    color: #000;

    @media (max-width: 769px) {
      text-align: center;
    }

    @media (max-width: 515px) {
      font-size: 24px;
    }
  }

  .questPageButton {
    max-width: 300px;

    @media (max-width: 515px) {
      max-width: 250px;
    }

    @media (max-width: 351px) {
      max-width: 150px;
    }
  }

  @media (max-width: 769px) {
    flex-direction: column;
  }
`;

export const Divisor = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  width: 100%;
  height: 2px;
  background-color: white;
  border: none;
`;

export const QuestRewardCurrencyContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  width: 100%;
  align-items: center;

  .description {
    color: #FFFFFF;
  }

  .currencyReward {
    color: #FFFFFF;
    padding: 5px 10px;
    border: 1px solid #FE501C;
    border-radius: 20px;
  }

  .currencySymbol {
    color: #FE501C;
  }

  @media (max-width: 400px) {
    flex-direction: column;
  }
`;
